module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAJCAYAAAAYcf3nAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAjSURBVHgBpcZBAQAABATBvUsgouYiEMFHA/Ma0RXgNOcVzQKykwNDhi7rdAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/Rectangle 234.png
// module id = YXog
// module chunks = 1